import { render, staticRenderFns } from "./CoursesKicker.vue?vue&type=template&id=911d7b42"
import script from "./CoursesKicker.vue?vue&type=script&lang=js"
export * from "./CoursesKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports